/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import { styled } from '@mui/material/styles';
import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#277EA1',
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 11
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#277EA1'
  }
}));
